module.exports = __webpack_public_path__ + "img/settings.c1efd222.jpg";